var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pdf-show',{ref:"pdfSearch",attrs:{"iframeSrc":_vm.src,"pdf-visible":_vm.pdfVisible},on:{"pdfCLose":_vm.pdfCLose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }